// src/components/salon-management/TabHeader.tsx
import React from "react";
import { useUserTheme } from "src/shared/utils/useUserTheme";
import { motion } from "framer-motion";

interface TabHeaderProps {
  activeTab: "Staffs" | "Services";
  setActiveTab: (tab: "Staffs" | "Services") => void;
  resetOrderFlow: () => void;
}

const TabHeader: React.FC<TabHeaderProps> = ({ activeTab, setActiveTab, resetOrderFlow,}) => {
  const { bgClass, fontClass, borderHighlight } = useUserTheme();

  return (
   <div className={`service-header ${fontClass} w-full -py-1`}>
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full gap-4 sm:gap-0">
        {/* Tabs Container */}
        <div className="relative">
          <div className="flex gap-1 p-1 bg-gray-100/80 backdrop-blur-sm rounded-2xl border border-gray-200/50">

            {/* Staffs Tab */}
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => setActiveTab("Staffs")}
              className={`relative px-6 py-3 rounded-xl text-sm font-semibold transition-all duration-200 ${
                activeTab === "Staffs"
                  ? "text-white"
                  : "text-gray-600 hover:text-gray-900 hover:bg-white/50"
              }`}
            >
              {activeTab === "Staffs" && (
                <motion.div
                  layoutId="activeTab"
                  className={`absolute inset-0 rounded-xl ${bgClass} shadow-lg border-2 ${borderHighlight}`}
                  transition={{ type: "spring", stiffness: 300, damping: 30 }}
                />
              )}

              <span className="relative z-10">Services</span>
            </motion.button>

            {/* Services Tab */}
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => setActiveTab("Services")}
              className={`relative px-6 py-3 rounded-xl text-sm font-semibold transition-all duration-200 ${
                activeTab === "Services"
                  ? "text-white"
                  : "text-gray-600 hover:text-gray-900 hover:bg-white/50"
              }`}
            >
              {activeTab === "Services" && (
                <motion.div
                  layoutId="activeTab"
                  className={`absolute inset-0 rounded-xl ${bgClass} shadow-lg border-2 ${borderHighlight}`}
                  transition={{ type: "spring", stiffness: 300, damping: 30 }}
                />
              )}

              <span className="relative z-10">Products</span>
            </motion.button>
          </div>
        </div>

        {/* New Order Button */}
        {/* <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={()=>window.location.reload()}
          className={`px-6 py-3 rounded-xl font-semibold text-white text-sm shadow-lg hover:shadow-xl transition-all duration-200 ${bgClass} backdrop-blur-sm border border-white/20`}
        >
          New Order
        </motion.button> */}
      </div>
    </div>
  );
};

export default TabHeader;
